import React, {
  PropTypes as T,
  Component,
} from 'react';
import radium from 'radium';
import { connect } from 'react-redux';

const styles = {
  wrap: {

  },
  title: {
    fontSize: 30,
    padding: '0px 16px',
    letterSpacing: 3,
    '@media (max-width: 767px)': {
      display: 'none',
    },
  },
  selectBox: {
    maxWidth: 378,
    width: '100%',
    position: 'relative',
    '@media (max-width: 767px)': {
      padding: '0px 10px',
      height: 'calc(100vh - 150px)',
      margin: '0 auto',
    },
  },
  select: {
    width: 378,
    height: 72,
    border: 0,
    margin: '0 12px',
    backgroundColor: '#FBBB0C',
    appearance: 'none',
    borderRadius: 2,
    padding: '0 16px 0 35%',
    lineHeight: '48px',
    fontSize: 24,
    color: 'white',
    cursor: 'pointer',
    outline: 'none',
    letterSpacing: 6,
    '@media (max-width: 1200px) and (min-width: 768px)': {
      width: 378,
    },
    '@media (max-width: 767px)': {
      width: '100%',
      lineHeight: '50px',
      height: 50,
      margin: '10px auto',
    },
  },
  triangle: {
    position: 'absolute',
    width: 20,
    height: 12,
    top: 0,
    right: 10,
    '@media (max-width: 767px)': {
      top: 9,
      right: 7,
      color: 'pink',
    },
  },
  svgWrap: {
    position: 'absolute',
    right: 10,
    top: 30,
    pointerEvents: 'none',
    '@media (max-width: 767px)': {
      width: 25,
      height: 25,
      border: '1px solid pink',
      borderRadius: '50%',
    },
  },
  mapWrap: {
    width: '100%',
    marginLeft: 280,
    '@media (max-width: 767px)': {
      margin: 0,
      textAlign: 'center',
    },
  },
  map: {
    width: 476,
    '@media (max-width: 767px)': {
      width: 'auto',
      height: 'calc(100vh - 300px)',
    },
  },
  mobileNext: {
    display: 'none',
    '@media (max-width: 767px)': {
      display: 'block',
      backgroundColor: '#FBBB0C',
      width: '100%',
      margin: '10px 0px',
      outline: 'none',
      border: 0,
      textAlign: 'center',
      lineHeight: '40px',
      color: 'white',
      fontSize: 18,
      letterSpacing: 1.5,
    },
  },
  hide: {
    display: 'none',
  },
};

class ReservationMap extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isHide: false,
    };
  }

  hideMap() {
    this.setState({
      isHide: true,
    });
  }

  render() {
    const {
      cities,
      selectCity,
      selectedCity,
      selectedCityMap,
    } = this.props;

    return (
      <div style={[styles.wrap, this.state.isHide && styles.hide]}>
        <h2 style={styles.title}>選擇城市</h2>
        <div style={styles.selectBox}>
          <select
            style={styles.select}
            key="city"
            value={selectedCity}
            onChange={(e) => selectCity(parseInt(e.target.value, 10))}>
            {cities.map(d => <option key={d.id} value={d.id}>{d.name}</option>)}
          </select>
          <div style={styles.svgWrap}>
            <svg style={styles.triangle} width="20" height="12">
              <path d="M2 2 L10 10 L19 2" fill="none" stroke="white" strokeWidth="2" id="svg-path" />
            </svg>
          </div>
          <div style={styles.mapWrap}>
            <img style={styles.map} src={selectedCityMap} role="presentation" />
          </div>
          <button type="button" style={styles.mobileNext} onClick={() => this.hideMap()}>下一步</button>
        </div>
      </div>
    );
  }
}

ReservationMap.propTypes = {
  cities: T.array,
  selectedCity: T.number,
  selectCity: T.func,
  selectedCityMap: T.string,
};

export default connect(
  () => ({

  }),
)(radium(ReservationMap));



// WEBPACK FOOTER //
// ./containers/Reservations/ReservationMap.js